import { arr } from "./Data";

export const changeLang=(key)=>{
    key = key.trim();

  for (let item of arr) {
    if (key.startsWith(item.key)) {
      const suffix = key.slice(item.key.length).trim(); // get the number or rest
      return `${item.value}${suffix ? " " + suffix : ""}`;
    }
  }
     return key?.slice(0,13);
    // }
  }